import { type FC, type HTMLAttributes, type PropsWithChildren } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const backgroundVariants = cva('', {
  variants: {
    variant: {
      onboarding: 'h-[48.3vh]',
      page: 'h-[46.87vh] min-h-[23.5rem]',
    },
  },
});

interface PageBackgroundProps
  extends VariantProps<typeof backgroundVariants>,
    PropsWithChildren {
  className?: string;
  pictureClassName?: string;
  backgroundImage: {
    png: string;
    webp: string;
  };
  style?: HTMLAttributes<HTMLDivElement>['style'];
}

const PageBackground: FC<PageBackgroundProps> = ({
  variant,
  className,
  pictureClassName,
  backgroundImage: { png, webp },
  children,
  style,
}) => {
  return (
    <div
      style={style}
      className={cn(
        css.onboardingBackground,
        backgroundVariants({ variant }),
        className,
      )}
    >
      <picture className={pictureClassName}>
        <source className={pictureClassName} srcSet={webp} type="image/webp" />
        <img
          className={cn('w-full h-full object-cover', pictureClassName)}
          src={png}
          alt="onboarding"
        />
      </picture>
      {children}
    </div>
  );
};

export { PageBackground };
